<template>
  <div style="width: 100%;height: 100%">
    <el-scrollbar style="height: 100%;padding-left: 3%;">
      <div style="height: 6%;position:relative;">
        <div style="font-size: 26px;font-weight: bolder;margin-left: 33%;margin-bottom: 1%">推广应用情况、经济效益和社会效益</div>
      </div>

      <div style="font-size: 16px;font-weight: bolder">1．推广应用情况（限500字，请依据客观数据和情况准确填写，不做评价性描述。）</div>
      <el-input
        :readonly="isDisabled"
        type="textarea"
        :autosize="{ minRows: 6}"
        placeholder="请输入内容"
        v-model="promotioncondition"
        maxlength="500"
        show-word-limit>
      </el-input>
      主要应用单位情况表
      <el-table
        :data="tableData01"
        border
        :cell-style="{borderColor:'lightgray'}"
        :header-cell-style="{borderColor:'lightgray'}"
        style="width: 100%">
        <el-table-column
          prop="unit"
          label="应用单位名称"
          width="230"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" type="textarea" :rows="2" v-model="tableData01[scope.$index].unit" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="technology"
          label="应用技术"
          width="230"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" type="textarea" :rows="2" v-model="tableData01[scope.$index].technology" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="startandenddate"
          label="应用的起止时间"
          align="center"
          show-overflow-tooltip
          width="220">
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" type="textarea" :rows="2" v-model="tableData01[scope.$index].startandenddate" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="peopleandphone"
          label="应用单位联系人/电话"
          align="center"
          show-overflow-tooltip
        width="260">
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" type="textarea" :rows="2" v-model="tableData01[scope.$index].peopleandphone" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="promotioncondition"
          label="推广应用情况"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" type="textarea" :rows="2" v-model="tableData01[scope.$index].promotioncondition" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          show-overflow-tooltip
          width="80">
          <template slot-scope="scope">
            <i class="el-icon-circle-plus-outline" @click="onAddRow(scope.$index)" style="cursor: pointer"></i>
            <i class="el-icon-remove-outline" @click="onDeleteRow(scope.$index)" style="cursor: pointer"></i>
          </template>
        </el-table-column>
      </el-table>
      <div style="font-size: 16px;font-weight: bolder">2．近三年主要经济效益（社会公益类项目可不填此栏）单位：万元人民币</div>
      <div style="background-color: white">
        <table cellspacing="0" style="width: 100%">
          <tr>
            <th rowspan="2" width="100px">年份</th>
            <th colspan="2">完成单位</th>
            <th colspan="2">其他应用单位</th>
          </tr>
          <tr>
            <th>新增销售额</th>
            <th>新增利润</th>
            <th>新增销售额</th>
            <th>新增利润</th>
          </tr>
          <tr>
            <td>{{ tableData02.year1 }}</td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.finishsale1" placeholder="请输入内容" @input="(val)=>{tableData02.finishsale1 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.finishprofit1" placeholder="请输入内容" @input="(val)=>{tableData02.finishprofit1 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.othersale1" placeholder="请输入内容" @input="(val)=>{tableData02.othersale1 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.otherprofit1" placeholder="请输入内容" @input="(val)=>{tableData02.otherprofit1 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
          </tr>
          <tr>
            <td>{{ tableData02.year2 }}</td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.finishsale2" placeholder="请输入内容" @input="(val)=>{tableData02.finishsale2 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.finishprofit2" placeholder="请输入内容" @input="(val)=>{tableData02.finishprofit2 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.othersale2" placeholder="请输入内容" @input="(val)=>{tableData02.othersale2 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.otherprofit2" placeholder="请输入内容" @input="(val)=>{tableData02.otherprofit2 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
          </tr>
          <tr>
            <td>{{ tableData02.year3 }}</td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.finishsale3" placeholder="请输入内容" @input="(val)=>{tableData02.finishsale3 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.finishprofit3" placeholder="请输入内容" @input="(val)=>{tableData02.finishprofit3 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.othersale3" placeholder="请输入内容" @input="(val)=>{tableData02.othersale3 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" v-model="tableData02.otherprofit3" placeholder="请输入内容" @input="(val)=>{tableData02.otherprofit3 = limitDecimalInputWithDigit(val, 4)}">
                <template slot="append">万元</template>
              </el-input>
            </td>
          </tr>
          <tr v-if="isDisabled">
            <td>累计</td>
            <td>
              <el-input :readonly="isDisabled" :value="tableData02.finishUnitSell" placeholder="请输入内容">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" :value="tableData02.finishUnitProfit" placeholder="请输入内容">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" :value="tableData02.otherFinishUnitSell" placeholder="请输入内容">
                <template slot="append">万元</template>
              </el-input>
            </td>
            <td>
              <el-input :readonly="isDisabled" :value="tableData02.otherFinishUnitProfit" placeholder="请输入内容">
                <template slot="append">万元</template>
              </el-input>
            </td>
          </tr>
        </table>
        主要经济效益指标的有关说明（限300字）：
        <el-input
          :readonly="isDisabled"
          type="textarea"
          :autosize="{ minRows: 6}"
          placeholder="请输入内容"
          v-model="tableData02.economicindicators"
          maxlength="300"
          show-word-limit>
        </el-input>
        其他经济效益指标的有关说明（限300字）：
        <el-input
          :readonly="isDisabled"
          type="textarea"
          :autosize="{ minRows: 6}"
          placeholder="请输入内容"
          v-model="tableData02.othereconomicindicators"
          maxlength="300"
          show-word-limit>
        </el-input>
      </div>
      <div style="font-size: 16px;font-weight: bolder">3．社会效益（限600 字）</div>
      <el-input
        :readonly="isDisabled"
        type="textarea"
        :autosize="{ minRows: 6}"
        placeholder="请输入内容"
        v-model="socialbenefit"
        maxlength="600"
        show-word-limit>
      </el-input>
      <div v-if="!isDisabled" style="width: 100%;margin-top:2%">
        <el-button type="info" @click="onReset" style="margin-left: 43%">重置</el-button>
        <el-button type="primary" @click="onSubmit" :disabled="isDisabledSubmit">保存</el-button>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import utils from "../../js/utils";

export default {
  name: "ProjectInfluence_05",
  data() {
    return {
      isShowSave: sessionStorage.getItem('pbcid') == undefined,
      isShowEdit: sessionStorage.getItem('pbcid') != undefined,
      createuserid: sessionStorage.getItem('createuserid'),
      isDisabled: sessionStorage.getItem('openWith') == 'readOnly' ? true : false,
      content: '',
      editor: null,   // 富文本编辑器对象
      editorOption: { //  富文本编辑器配置
        modules: {
          toolbar: '#toolbar'
        },
        theme: 'snow',
        placeholder: '请输入正文'
      },
      promotioncondition: '',
      tableData01: [{
        pbcid: sessionStorage.getItem('pbcid'),
        unit: '',
        technology: '',
        startandenddate: '',
        peopleandphone: '',
        promotioncondition: '',
      }],
      tableData02: {
        pbcid: sessionStorage.getItem('pbcid'),
        year1: (new Date().getFullYear() - 3).toString(),
        year2: (new Date().getFullYear() - 2).toString(),
        year3: (new Date().getFullYear() - 1).toString(),

        // finishsale1:0,
        // finishprofit1:0,
        // othersale1:0,
        // otherprofit1:0,
        // finishsale2:0,
        // finishprofit2:0,
        // othersale2:0,
        // otherprofit2:0,
        // finishsale3:0,
        // finishprofit3:0,
        // othersale3:0,
        // otherprofit3:0,

        economicindicators: '',
        othereconomicindicators: '',
      },
      finishUnitSell:0,
      finishUnitProfit:0,
      otherFinishUnitSell:0,
      otherFinishUnitProfit:0,
      socialbenefit: '',
      pcid: '',
      isDisabledSubmit:false
    }
  },
  methods: {
    // js methods部分
    // 准备富文本编辑器
    onEditorReady(editor) {
    },
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {
    },
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {
    },
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
    },
    getData() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectpromotion',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid'))
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          if (resp.data !== null) {
            this.promotioncondition = resp.data.promotioncondition
            this.socialbenefit = resp.data.socialbenefit
            this.tableData01 = resp.data.applyUnitList
            this.tableData02 = resp.data.economicBenefit
            this.pcid = resp.data.pcid
            // this.isDisabledSubmit=false
            this.closeLoading()
          }
        } else {
          this.closeLoading()
          this.showFailMsg(resp.message)
          // this.isDisabledSubmit=false
        }
      })
    },
    onAddRow(index) {
      if (this.isDisabled) {
        return
      }
      this.tableData01.push({
        pbcid: sessionStorage.getItem('pbcid'),
        unit: '',
        technology: '',
        startandenddate: '',
        peopleandphone: '',
        promotioncondition: '',
      })
    },
    onDeleteRow() {
      if (this.isDisabled||this.tableData01.length==1) {
        return
      }
      this.tableData01.pop()
    },
    onSubmit() {
      /*this.tableData01.forEach(item=>{
        if(item.unit===''||item.technology===''||item.startandenddate===''||item.peopleandphone===''||item.promotioncondition===''){
          this.showNotifyError('请完善表格数据！');
          return ;
        }
      })*/
      for (let i = 0; i < this.tableData01.length; i++) {
        if(this.tableData01[i].unit===''||this.tableData01[i].technology===''||this.tableData01[i].startandenddate===''||this.tableData01[i].peopleandphone===''||this.tableData01[i].promotioncondition===''){
          this.showNotifyError('请完善表格数据！');
          return ;
        }
      }
      if (this.pcid == '') {
        this.onSaveSubmit()
      } else {
        this.onEditSubmit()
      }
    },
    onSaveSubmit() {
      this.openLoading("内容提交中","提交失败，请检查网络",7000)
      // this.isDisabledSubmit=true
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/user/addprojectpromotion',
        data: {
          pbcid: sessionStorage.getItem('pbcid'),
          promotioncondition: this.promotioncondition,
          applyUnitDTOList: this.tableData01,
          economicBenefitWithBLOBs: this.tableData02,
          socialbenefit: this.socialbenefit,
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.getData()
        } else {
          this.closeLoading()
          this.showFailMsg(resp.message)
          // this.isDisabledSubmit=false
        }
      })
      // setTimeout(()=>{
      //   if(this.isDisabledSubmit){
      //     this.isDisabledSubmit=false
      //   }
      // },7000)
    },
    onEditSubmit() {
      this.openLoading("内容提交中","提交失败，请检查网络",7000)
      // this.isDisabledSubmit=true
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/user/updateprojectpromotion',
        data: {
          pbcid: sessionStorage.getItem('pbcid'),
          pcid: this.pcid,
          promotioncondition: this.promotioncondition,
          applyUnitDTOList: this.tableData01,
          economicBenefitWithBLOBs: this.tableData02,
          socialbenefit: this.socialbenefit,
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        // this.isDisabledSubmit=false
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.getData()
        } else {
          this.closeLoading()
          this.showFailMsg(resp.message)
        }
      })
      // setTimeout(()=>{
      //   if(this.isDisabledSubmit){
      //     this.isDisabledSubmit=false
      //   }
      // },7000)
    },
    onReset() {
      this.promotioncondition = ''
      this.tableData01 = [{
        pbcid: sessionStorage.getItem('pbcid'),
        unit: '',
        technology: '',
        startandenddate: '',
        peopleandphone: '',
        promotioncondition: '',
      }]
      this.tableData02 = {
        pbcid: sessionStorage.getItem('pbcid'),
        ebid: this.tableData02.ebid,
        year1: (new Date().getFullYear() - 3).toString(),
        year2: (new Date().getFullYear() - 2).toString(),
        year3: (new Date().getFullYear() - 1).toString(),
        economicindicators: '',
        othereconomicindicators: '',
      }
      this.socialbenefit = ''
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    if (sessionStorage.getItem('pbcid') == undefined) {
      this.$message.error('请先填写项目基本情况表');
      this.$router.push({
        path: '/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'
      })
    }
  },
  // watch:{
  //   finishUnitSell(){
  //     return this.tableData02.finishsale1+this.tableData02.finishsale2+this.tableData02.finishsale3
  //   },
  //   finishUnitProfit(){
  //     return this.tableData02.finishprofit1+this.tableData02.finishprofit2+this.tableData02.finishprofit3
  //   },
  //   otherFinishUnitSell(){
  //     return this.tableData02.othersale1+this.tableData02.othersale1+this.tableData02.othersale1
  //   },
  //   otherFinishUnitProfit(){
  //     return this.tableData02.otherprofit1+this.tableData02.otherprofit2+this.tableData02.otherprofit3
  //   }
  // }
}
</script>

<style scoped>
/deep/ .el-scrollbar__wrap {
  overflow: hidden scroll;
  height: 100%;
}

table, td, th {
  border: 0.5px solid lightgray;
  text-align: center;
  font-size: 18px;
}

/deep/ .el-textarea__inner {
  resize: none;
  padding: 0;
  border: none;
}
/deep/ .el-table .el-table__cell {
  padding: 0px;
}

/deep/ .el-table .cell {
  padding: 5px 3px;
}

/deep/ .el-table th.el-table__cell > .cell {
  padding: 10px 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/ProjectInfluence_05.vue